import type { RSSFeedDataPodcast, RSSFeedDataYouTube } from '@shared/dream-components';
import { useQuery } from '@tanstack/react-query';

interface Props {
  url: string;
}

const useRssFeed = ({ url }: Props) => {
  return useQuery({
    queryKey: ['rssFeed', url],
    enabled: Boolean(url),
    retry: false,
    queryFn: async ({ signal }) => {
      const response = await fetch('/rss_feed', {
        method: 'POST',
        headers: {
          'Sec-Fetch-Dest': 'empty',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ url }),
        signal,
      });

      const result: unknown = await response.json();

      // `routes/__actions/rss_feed.tsx` returns `[]` when it catches an error.
      // Treat this as "no data" so call sites can fall back to node attrs.
      if (Array.isArray(result)) return undefined;

      return result as RSSFeedDataPodcast | RSSFeedDataYouTube;
    },
  });
};

export default useRssFeed;
